import { BrowserRouter as Router } from "react-router-dom";

import AuthProvider from "./contexts/AuthProvider.jsx";
import Routes from "./routes/AppRoutes.jsx";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes />
      </Router>
    </AuthProvider>
  );
}

export default App;
